(function () {
  'use strict';

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getLineQuantity(item) {
    return Math.max(1, item.quantity || 1);
  }

  function scaleLineCents(lineCents, wizardQty, quantity) {
    if (!lineCents || lineCents <= 0) return 0;
    var baseQty = Math.max(1, wizardQty || 1);
    return Math.round((lineCents / baseQty) * getLineQuantity({ quantity: quantity }));
  }

  window.MSCartPricing = {
    isCheckoutAdjustmentLine: function (item) {
      var props = item.properties || {};
      return props['_Line role'] === 'checkout-adjustment' || props['_Hidden'] === 'true';
    },

    isCampaignLine: function (item) {
      var props = item.properties || {};
      if (props['_Line role'] === 'campaign') return true;
      if (window.MSCartPricing.isCheckoutAdjustmentLine(item)) return false;
      return window.MSCartPricing.hasOfferPrice(item);
    },

    getVisibleItemCount: function (cart) {
      var count = 0;
      (cart.items || []).forEach(function (item) {
        if (window.MSCartPricing.isCheckoutAdjustmentLine(item)) return;
        count += Math.max(1, item.quantity || 1);
      });
      return count;
    },

    parseMoneyToCents: function (value) {
      if (!value) return 0;
      var cleaned = String(value).replace(/[^0-9.]/g, '');
      var dollars = parseFloat(cleaned);
      return isNaN(dollars) ? 0 : Math.round(dollars * 100);
    },

    getItemTotalCents: function (item) {
      var props = item.properties || {};
      var unitCents = parseInt(props['_Unit total cents'], 10);
      if (unitCents > 0) return unitCents * getLineQuantity(item);

      var wizardQty = parseInt(props['_Wizard qty'], 10) || 0;
      var lineCents = parseInt(props['_Total cents'], 10);
      if (lineCents > 0) {
        return scaleLineCents(lineCents, wizardQty, item.quantity);
      }

      var parsed = window.MSCartPricing.parseMoneyToCents(props.Total);
      if (parsed > 0) {
        return scaleLineCents(parsed, wizardQty || 1, item.quantity);
      }

      return item.final_line_price || 0;
    },

    getItemCompareCents: function (item) {
      var props = item.properties || {};
      var totalCents = window.MSCartPricing.getItemTotalCents(item);
      var unitCompare = parseInt(props['_Unit compare cents'], 10);
      if (unitCompare > 0) return unitCompare * getLineQuantity(item);

      var wizardQty = parseInt(props['_Wizard qty'], 10) || 0;
      var compareCents = parseInt(props['_Compare cents'], 10);
      if (compareCents > 0) {
        var scaled = scaleLineCents(compareCents, wizardQty, item.quantity);
        if (scaled > totalCents) return scaled;
      }

      var parsed = window.MSCartPricing.parseMoneyToCents(props['_Compare total']);
      if (parsed > totalCents) {
        return scaleLineCents(parsed, wizardQty || 1, item.quantity);
      }

      return item.final_line_price || 0;
    },

    hasOfferPrice: function (item) {
      var props = item.properties || {};
      if (parseInt(props['_Unit total cents'], 10) > 0) return true;
      if (parseInt(props['_Total cents'], 10) > 0) return true;
      return window.MSCartPricing.parseMoneyToCents(props.Total) > 0;
    },

    getCartSubtotalCents: function (cart) {
      var total = 0;
      (cart.items || []).forEach(function (item) {
        if (window.MSCartPricing.isCheckoutAdjustmentLine(item)) return;
        total += window.MSCartPricing.getItemTotalCents(item);
      });
      return total;
    },

    getCartCompareCents: function (cart) {
      var compare = 0;
      var offer = 0;
      var hasOffer = false;
      (cart.items || []).forEach(function (item) {
        if (window.MSCartPricing.isCheckoutAdjustmentLine(item)) return;
        if (window.MSCartPricing.hasOfferPrice(item)) {
          hasOffer = true;
          compare += window.MSCartPricing.getItemCompareCents(item);
          offer += window.MSCartPricing.getItemTotalCents(item);
        } else {
          compare += item.final_line_price || 0;
          offer += item.final_line_price || 0;
        }
      });
      return hasOffer && compare > offer ? compare : 0;
    },

    formatItemPriceHtml: function (item, formatMoney) {
      if (!window.MSCartPricing.hasOfferPrice(item)) {
        return formatMoney(item.final_line_price);
      }

      var totalCents = window.MSCartPricing.getItemTotalCents(item);
      var compareCents = window.MSCartPricing.getItemCompareCents(item);
      var html = '<span class="cart-offer-price">';

      if (compareCents > totalCents) {
        html += '<span class="cart-offer-price__compare">' +
          escapeHtml(formatMoney(compareCents)) + '</span>';
      }

      html += '<span class="cart-offer-price__amount">' +
        escapeHtml(formatMoney(totalCents)) + '</span></span>';
      return html;
    },

    formatSubtotalHtml: function (cart, formatMoney) {
      var subtotalCents = window.MSCartPricing.getCartSubtotalCents(cart);
      var compareCents = window.MSCartPricing.getCartCompareCents(cart);
      var discountCents = cart.total_discount || 0;
      var totalCents = cart.total_price || subtotalCents;

      if (discountCents > 0) {
        return (
          '<span class="cart-offer-price cart-offer-price--subtotal">' +
            (compareCents > subtotalCents
              ? '<span class="cart-offer-price__compare">' + formatMoney(compareCents) + '</span>'
              : '') +
            '<span class="cart-offer-price__amount">' + formatMoney(totalCents) + '</span>' +
          '</span>'
        );
      }

      if (compareCents > subtotalCents) {
        return (
          '<span class="cart-offer-price cart-offer-price--subtotal">' +
            '<span class="cart-offer-price__compare">' + formatMoney(compareCents) + '</span>' +
            '<span class="cart-offer-price__amount">' + formatMoney(subtotalCents) + '</span>' +
          '</span>'
        );
      }

      return formatMoney(subtotalCents);
    },

    getCartDiscountCents: function (cart) {
      return cart && cart.total_discount ? cart.total_discount : 0;
    },

    getCartTotalCents: function (cart) {
      if (!cart) return 0;
      if (cart.total_price) return cart.total_price;
      return window.MSCartPricing.getCartSubtotalCents(cart);
    },

    getExpectedAdjustmentQty: function (campaignItem, adjustmentItem) {
      var props = campaignItem.properties || {};
      var unitTotal = parseInt(props['_Unit total cents'], 10);
      var variantUnit = parseInt(props['_Variant unit cents'], 10);
      if (unitTotal <= 0 || variantUnit < 0) return 0;

      var adjustmentCents = Math.max(0, (unitTotal - variantUnit) * Math.max(1, campaignItem.quantity || 1));
      var adjUnit = parseInt((adjustmentItem && adjustmentItem.properties || {})['_Adjustment unit cents'], 10) ||
        (adjustmentItem && adjustmentItem.price) ||
        parseInt(props['_Adjustment unit cents'], 10) ||
        100;

      if (!adjUnit) return 0;
      if (adjUnit === 1) return adjustmentCents;
      return Math.max(0, Math.round(adjustmentCents / adjUnit));
    },

    findLinkedAdjustmentItem: function (cart, campaignItem) {
      var bundleId = (campaignItem.properties || {})['_Bundle id'];
      if (!bundleId || !cart || !cart.items) return null;
      return cart.items.find(function (item) {
        var props = item.properties || {};
        return props['_Bundle id'] === bundleId &&
          props['_Line role'] === 'checkout-adjustment';
      }) || null;
    },

    syncBundleAdjustments: function (cart) {
      if (!cart || !Array.isArray(cart.items)) return Promise.resolve(cart);

      var updates = [];
      cart.items.forEach(function (item) {
        if ((item.properties || {})['_Line role'] !== 'campaign') return;
        var adjustment = window.MSCartPricing.findLinkedAdjustmentItem(cart, item);
        if (!adjustment) return;
        var expectedQty = window.MSCartPricing.getExpectedAdjustmentQty(item, adjustment);
        if (adjustment.quantity === expectedQty) return;
        updates.push(
          fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: adjustment.key, quantity: expectedQty })
          })
        );
      });

      if (!updates.length) return Promise.resolve(cart);
      return Promise.all(updates)
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' }).then(function (res) { return res.json(); });
        })
        .catch(function () { return cart; });
    }
  };
})();
